module.exports = __webpack_public_path__ + "static/media/Cardio.42633068.jpeg";